import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CancelConfirmationError } from '@core/errors';

import { ConfirmationDialogModule } from './confirmation-dialog.module';
import { ConfirmationDialogComponent, ConfirmData } from './confirmation-dialog.component';

@Injectable({
  providedIn: ConfirmationDialogModule
})
export class ConfirmationDialogService {

  dialogRef;

  constructor(private dialog: MatDialog) { }

  confirm(data: ConfirmData): Promise<any> {

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data
    });

    return this.dialogRef.beforeClosed()
      .pipe(switchMap((result) => {
        if (result) {
          return of(true);
        } else {
          return throwError(new CancelConfirmationError())
        }
      })).toPromise();
  }

  reset() {
    this.dialogRef && this.dialogRef.componentInstance && this.dialogRef.componentInstance.onNoClick();
  }
}
